import ActionResult from './component';

export default ActionResult;
